import _ from "lodash";
import React, { useEffect, useState } from "react";

import { BehavioralGoalsRating } from "@/features/notes/(v2)/components/BehavioralGoalsRating";
import CardSecondary from "@/components/UI/Card/CardSecondary";
import GenericSlider from "@/components/Common/GenericSlider/GenericSlider";
import { POST_SESSION_SURVEY_LABEL_MAP } from "@/constants/rating";

import "./styles.scss";

const PostSessionSurveyQuestion = (props) => {
  const { className, handleEditChange, questionIndex, surveyQuestion, tutorialLightUp } = props;
  const [question, setQuestion] = useState(surveyQuestion);

  useEffect(() => {
    setQuestion(surveyQuestion);
  }, [surveyQuestion]);

  const label = _.get(question, "label", "");

  const desktopDisplay = (
    <div className="BehavioralGoalsRating--pss">
      <BehavioralGoalsRating
        height={25}
        isEditing={true}
        labelsEnabled={true}
        onClick={(e) => handleEditChange(e, questionIndex, "answer")}
        optionLabelMap={POST_SESSION_SURVEY_LABEL_MAP}
        progress={question}
      />
    </div>
  );

  const mobileDisplay = (
    <div className="GenericSlider--pss">
      <GenericSlider
        forceActive={props.forceActive}
        height={25}
        isEditing={true}
        labelsEnabled={true}
        onClick={(e) => handleEditChange(e, questionIndex, "answer")}
        optionLabelMap={POST_SESSION_SURVEY_LABEL_MAP}
        progress={question}
      />
    </div>
  );

  const tutorialCardOverlayLightUp = tutorialLightUp ? "tutorial-card-overlay-light-up" : "";

  return (
    <CardSecondary className={`px-2 py-2 my-4 ${className} ${tutorialCardOverlayLightUp}`}>
      {props.tutorialComponent}
      <div className="container">
        <div className="row mb-2">
          <div className="col">
            <label className="tw:font-bold">{label}</label>
          </div>
        </div>
        <div className="row">
          <div className="col">
            {desktopDisplay}
            {mobileDisplay}
          </div>
        </div>
      </div>
    </CardSecondary>
  );
};

export default PostSessionSurveyQuestion;
